import { DBConfig } from "ngx-indexed-db";
import { indexedDbMigrationFactory } from "./indexedDb-migration-factory";

export const localDdbConfig: DBConfig = {
    name: 'CabinCrewReportDb',
    version: 4,
    objectStoresMeta: [
        {
            store: 'reports',
            storeConfig: {
                keyPath: 'id',
                autoIncrement: true
            },
            storeSchema: [
                { name: 'creationDate', keypath: 'creationDate', options: { unique: false } },
                { name: 'request', keypath: 'request', options: { unique: false } }
            ]
        }
    ],
    migrationFactory: indexedDbMigrationFactory
}